import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController, NavParams } from '@ionic/angular';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  selector: 'app-connect-jsm-instance-modal',
  templateUrl: './connect-jsm-instance-modal.component.html',
})
export class ConnectJsmInstanceModalComponent {
  instanceName: string;
  accountAccessToken?: string;

  constructor(
    private modalCtrl: ModalController,
    navParams: NavParams,
  ) {
    // Pre-populate for reconnect flow
    this.instanceName = navParams.get('instanceName') || '';
    this.accountAccessToken = navParams.get('accountAccessToken') || '';
  }

  submit() {
    if (!this.instanceName || !this.instanceName.trim()) {
      return;
    }

    this.modalCtrl.dismiss({
      instanceName: this.instanceName.trim(),
      accountAccessToken: this.accountAccessToken?.trim(),
    });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
